<mat-tab-group #tabGroup (selectedIndexChange)="resetItemData($event)" mat-align-tabs="end" animationDuration="0ms">
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="lgi-tab-icon">list</mat-icon>
            Legislation Items
        </ng-template>
        <ng-template matTabContent>
            <app-legislation-items (editLegislationItem)="editLegislationItem($event)"></app-legislation-items>
        </ng-template>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="lgi-tab-icon">{{ injectedItemData ? 'edit' : 'add' }}</mat-icon>
            {{ injectedItemData ? 'Edit Item' : 'Add Item' }}
        </ng-template>
        <ng-template matTabContent>
            <app-add-edit-item [injectedData]="injectedItemData" [creatingNew]="creatingNew" (goToListView)="goToListView($event)"></app-add-edit-item>
        </ng-template>
    </mat-tab>
</mat-tab-group>

